import React from "react";
import { Modal, Button } from "react-bootstrap";

const VideoModal = ({ showModal, triggerModal }) => (
	<Modal
		show={showModal}
		fullscreen={true}
		onHide={triggerModal}
		size='lg'
		centered>
		<iframe
			style={{ borderRadius: 20, minHeight: 500 }}
			width='100%'
			height='auto'
			src='https://www.youtube.com/embed/jL4wEc4yHi8'
			title='YouTube video player'
			frameBorder='0'
			allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
			allowFullScreen></iframe>
	</Modal>
);

export default VideoModal;
